import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheComuniApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useNazioniDataSource() {
    const api = new AnagraficheComuniApi(apiConfiguration);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getNazioni();
          },
    
          byKey: (key) => {
            return api.getNazioneById({
                nazioneId: key
            });
          }
        });
      }, []);
    
      return dataSource;
}


